import serviceTasksApiService from '@/services/api/ServiceTasks'

const REQUEST_STATUS_PENDING = 'pending'
const REQUEST_STATUS_ACCEPTED = 'accepted'
const REQUEST_STATUS_DENIED = 'denied'

const CATEGORY_SPECIFIC = 'specific'
const CATEGORY_SEASONAL = 'seasonal'
const CATEGORY_WINTERING = 'wintering'

const METHOD_REPAIR = 'repair'
const METHOD_SERVICE = 'service'

const ASSIGNEE_TYPE_STAFF = 'staff'
const ASSIGNEE_TYPE_CONTRACTOR = 'contractor'

const PRIORITY_NORMAL = 1
const PRIORITY_HIGH = 2
const PRIORITY_CRITICAL = 3

const ASSIGNEE_TYPE_DATA = {
  [ASSIGNEE_TYPE_STAFF]: {
    key: ASSIGNEE_TYPE_STAFF,
    label: 'Staff',
    icon: 'fa fa-user'
  },
  [ASSIGNEE_TYPE_CONTRACTOR]: {
    key: ASSIGNEE_TYPE_CONTRACTOR,
    label: 'Contractor',
    icon: 'fa fa-store-alt'
  }
}

const REQUEST_STATUS_DATA = {
  [REQUEST_STATUS_PENDING]: {
    color: 'grey darken-1',
    label: 'Pending',
    key: REQUEST_STATUS_PENDING
  },
  [REQUEST_STATUS_ACCEPTED]: {
    color: 'green',
    label: 'Accepted',
    key: REQUEST_STATUS_ACCEPTED
  },
  [REQUEST_STATUS_DENIED]: {
    color: 'red',
    label: 'Denied',
    key: REQUEST_STATUS_DENIED
  }
}

const PRIORITY_DATA = {
  [PRIORITY_NORMAL]: {
    color: 'blue',
    label: 'Normal',
    key: PRIORITY_NORMAL
  },
  [PRIORITY_HIGH]: {
    color: 'orange',
    label: 'High',
    key: PRIORITY_HIGH
  },
  [PRIORITY_CRITICAL]: {
    color: 'red',
    label: 'Critical',
    key: PRIORITY_CRITICAL
  }
}

const emptyModel = {
  id: null,
  category: CATEGORY_SEASONAL,
  yacht_id: null,
  yacht: null,
  service_tasks_repository_id: null,
  service_tasks_repository: null,
  finished: true,
  finished_at: null,
  method: METHOD_SERVICE,
  hours_spent: null,
  total_hours_spent: null,
  request_status: null,
  hull_insurance: false,
  deposit_insurance: false,
  is_warranty_claim: false,
  warranty_insurance_note: '',
  warranty_claim_resolution: null,
  warranty_claim_resolution_by_id: null,
  warranty_claim_accepted_amount: null,
  warranty_claim_accepted_amount_currency: 'EUR',
  is_intervention: false,
  priority: PRIORITY_NORMAL,
  is_time_log: false,
  inventory_items: [],
  custom_parts: [],
  assigned_to: [],
  files: [],
  due_at: null,
  description: null,
  images: []
}

const emptyFilters = {
  request_status: null,
  title: null,
  categories: [],
  yacht_ids: [],
  assigned_to: [],
  priority: null,
  finished: false,
  finished_at_from: null,
  finished_at_to: null,
  warranty_claim_status: null,
  insurance_claim: null,
  id: null,
  organisation_id: null
}

const CATEGORY_DATA = [
  {
    label: 'Seasonal',
    key: CATEGORY_SEASONAL
  },
  {
    label: 'Annual',
    key: CATEGORY_WINTERING
  }
]

const METHOD_DATA = [
  {
    key: METHOD_SERVICE,
    label: 'Service'
  },
  {
    key: METHOD_REPAIR,
    label: 'Repair'
  }
]

class ServiceTask {
  constructor() {
    this.api = serviceTasksApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
    this.requestStatusData = REQUEST_STATUS_DATA
    this.categoryData = CATEGORY_DATA

    this.REQUEST_STATUS_PENDING = REQUEST_STATUS_PENDING
    this.REQUEST_STATUS_ACCEPTED = REQUEST_STATUS_ACCEPTED
    this.REQUEST_STATUS_DENIED = REQUEST_STATUS_DENIED

    this.CATEGORY_SEASONAL = CATEGORY_SEASONAL
    this.CATEGORY_SPECIFIC = CATEGORY_SPECIFIC
    this.CATEGORY_WINTERING = CATEGORY_WINTERING

    this.methodData = METHOD_DATA
    this.METHOD_REPAIR = METHOD_REPAIR
    this.METHOD_SERVICE = METHOD_SERVICE

    this.assigneeTypeData = ASSIGNEE_TYPE_DATA
    this.ASSIGNEE_TYPE_STAFF = ASSIGNEE_TYPE_STAFF
    this.ASSIGNEE_TYPE_CONTRACTOR = ASSIGNEE_TYPE_CONTRACTOR

    this.PRIORITY_NORMAL = PRIORITY_NORMAL
    this.PRIORITY_HIGH = PRIORITY_HIGH
    this.PRIORITY_CRITICAL = PRIORITY_CRITICAL
    this.priorityData = PRIORITY_DATA
  }
}

let serviceTask = new ServiceTask()

export default serviceTask
